(function () {
  var BADGES = [
    '90 Day Returns',
    '+1 Year Extended Warranty',
    '$50 Off at Checkout (Code: PREPAY)'
  ];

  var ICON_SVG =
    '<svg class="squarecable-product-badges__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="#48A311" aria-hidden="true" focusable="false">' +
    '<path d="M7.6 13.2L14.65 6.15L13.25 4.75L7.6 10.4L4.75 7.55L3.35 8.95L7.6 13.2ZM0 18V0H18V18H0ZM2 16H16V2H2V16Z"/>' +
    '</svg>';

  function injectBadges() {
    var block = document.querySelector('.ecom-block.ecom-jbv2ftxarzp');
    if (!block || block.querySelector('.squarecable-product-badges')) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'squarecable-product-badges';
    wrapper.setAttribute('role', 'list');

    wrapper.innerHTML = BADGES.map(function (label) {
      return (
        '<div class="squarecable-product-badges__item" role="listitem">' +
          ICON_SVG +
          '<span>' + label + '</span>' +
        '</div>'
      );
    }).join('');

    block.appendChild(wrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectBadges);
  } else {
    injectBadges();
  }
})();
